<template>
  <div class="test">
    <div class="save">
      <el-row type="flex">
        <el-button :disabled="isSaveBlocked" type="primary" @click="save">
          {{ isBlocked ? 'Projekt zablokowany' : 'Zapisz' }}
        </el-button>
        <el-button :disabled="isPreview || loading" v-if="showSendProject" type="success" @click="sendDialogVisible = true">Prześlij</el-button>
      </el-row>
    </div>

      <el-dialog title="Czy wysłać projekt?" :visible.sync="sendDialogVisible" width="20%" :close-on-click-modal="false">
        <span>
          Drogi Użytkowniku.Upewnij się, że wszystkie wprowadzone przez Ciebie dane są poprawne, a teksty nie wykraczają poza obszar spadu i bezpiecznego zadruku. Po przesłaniu projektu do druku nie będzie możliwości wprowadzania zmian. Uszlachetnienia (złocenie, srebrzenie itd.), kolory papierów oraz dodatki (sznurki, wstążki itd.) nie są widoczne na projekcie, ale będą zastosowane zgodnie z zamówieniem.
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="sendDialogVisible = false">Anuluj</el-button>
          <el-button type="success" @click="send">Prześlij</el-button>
        </span>
      </el-dialog>
      <el-dialog title="Zapisz projekt" :visible.sync="saveDialogVisible" width="20%" :close-on-click-modal="false">
        <el-form ref="form" :model="saveProjectData" :rules="rules">
          <el-form-item prop="user_name">
            <el-input placeholder="Imię i Nazwisko" v-model="saveProjectData.user_name"></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input placeholder="Adres e-mail" v-model="saveProjectData.email"></el-input>
          </el-form-item>
          <small>Na podany adres e-mail prześlemy dane do edycji Twojego projektu w dowolnym momencie.</small>
          <el-form-item class="buttons">
            <el-button type="primary" @click="createProject" :disabled="isLoading">Zapisz</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Editor from '../../classes/Editor'

  export default {
    data() {
      return {
        sendProject: false,
        isLoading: false,
        sendDialogVisible: false,
        saveDialogVisible: false,
        saveTemplateDialogVisible: false,
        saveProjectData: {
          user_name: '',
          // hash: '',
          email: '',
          // scenes: '',
          orderId: null,
        },
        saveTemplateData: {
          name: '',
          code: '',
          photo: '',
          scenes: '',
        }
      }
    },
    computed: {
      ...mapGetters('creator', [
        'project',
        'activeScene',
        'isPreview',
        'loading',
        'isBlocked'
      ]),
      ...mapGetters('user', [
        'loggedIn',
      ]),
      isSaveBlocked() {
        return this.isPreview || this.loading || this.isBlocked
      },
      showSendProject() {
        if (this.loggedIn) {
          return false
        }
        const isOrderId = this.project.order_id || this.$route.params.orderId

        return isOrderId && !this.isBlocked
      },
      rules() {
        return {
        user_name: [
          { required: true, message: 'Pole imię i nazwisko jest wymagane', trigger: 'blur' },
          { min: 5, max: 100, message: 'Imie i naziwsko nie może być krótsze niż 5 znaków i dłuższe niż 100 znaków', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Pole adres e-mail jest wymagane', trigger: 'blur' },
          { type: 'email', message: 'Podaj poprawny adres e-mail', trigger: 'blur' }
        ],
      }
      }
    },
    methods: {
      ...mapActions('creator', {
        updateDraft: 'updateDraft',
        setStatus: 'setStatus',
        saveProject: 'saveProject',
      }),
      async save() {

        // We have to clear selection before send project because if active object is a 
        // text type then fabric set lockMovementX/Y to prevent object moving and that
        // state is also saved. After project reload, we can't moving that object
        Editor.canvas.discardActiveObject()

        if (this.loggedIn && !this.project.hash) {
          this.createTemplate()
        } else if (this.project.hash) {
          console.log('save user project');
          await this.saveProjectDate()
        } else {
          this.saveDialogVisible = true
        }
      },
      createTemplate() {
        
        this.updateDraft()
          .then(() => {
            this.saveTemplateDialogVisible = false;

            this.$notify({
              title: 'OK!',
              message: 'Szablon został pomyślnie zapisany',
              type: 'success',
              position: 'bottom-right'
            });
          })
          .catch((e) => {
            console.log(e);
            this.saveTemplateDialogVisible = false;
            
            this.$notify.error({
              title: 'Ups!',
              message: 'Wystąpił błąd podczas zapisywania szablonu',
              position: 'bottom-right'
            });
          })
      },
      async saveProjectDate() {
        try {

          if (this.isBlocked) {
              this.$alert('Projekt jest w trakcie realizacji, jego edycja jest zablokowana.', 'Ups...', {
                confirmButtonText: 'OK',
                type: 'warning',
              });

              return
          }

          this.saveProjectData.orderId = this.$route.params.orderId

          const result = await this.saveProject(this.saveProjectData)

          this.saveDialogVisible = false

            this.$notify({
              title: 'OK!',
              message: 'Projekt został pomyślnie zapisany',
              type: 'success',
              position: 'bottom-right'
            });

          if (this.sendProject) {
            this.sendAction()
          }

          return result

        } catch (e) {
          console.log('error e', e)
          this.saveDialogVisible = false
            this.$notify.error({
              title: 'Ups!',
              message: 'Wystąpił błąd podczas zapisywania projektu',
              position: 'bottom-right'
            });
        }
      },
      async createProject() {

        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.isLoading = true

            const project = await this.saveProjectDate()

            this.isLoading = false

            window.history.pushState({}, '', `/editor/${project.hash}`);
          } else {
            return false;
          }
        });
      },
      async send() {

        if (this.isBlocked) {
          return
        }

        this.sendProject = true

        this.save()
      },

      async sendAction() {
        this.sendDialogVisible = false

        const project = await this.setStatus('project_approved')

        this.sendProject = false;

        if (project) {
          this.$notify({
            title: 'OK!',
            message: 'Projekt został pomyślnie przesłany',
            type: 'success',
            position: 'bottom-right'
          });
        } else {
          this.$notify.error({
            title: 'Ups!',
            message: 'Wystąpił błąd podczas przesyłania projektu',
            position: 'bottom-right'
          });
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .save {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    padding: 15px 25px;
    width: 400px;
    box-sizing: border-box;
    z-index: 10;
    box-shadow: -1px -1px 2px #e1e1e1;
    .el-row .el-button {
      width: 100%;
    }
  }

  .el-form-item__error {
    position: static;
    line-height: 16px;
  }

  .buttons {
    margin-top: 20px;
  }
</style>
